import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconStrikethroughBox16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconStrikethroughBox16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M14.854 1.854a.5.5 0 0 0-.708-.708l-1.13 1.13A2 2 0 0 0 12 2H4a2 2 0 0 0-2 2v8c0 .37.101.718.277 1.016l-1.13 1.13a.5.5 0 0 0 .707.708l1.13-1.13A2 2 0 0 0 4 14h8a2 2 0 0 0 2-2V4c0-.37-.101-.718-.277-1.016zm-2.595 1.18A1 1 0 0 0 12 3H4a1 1 0 0 0-1 1v8q0 .135.034.259zm-8.518 9.932 9.225-9.225Q13 3.866 13 4v8a1 1 0 0 1-1 1H4q-.135 0-.259-.034"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconStrikethroughBox16);
